// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationPageTitleStyles } from "@awc/App/Widgets/OrderConfirmation/OrderConfirmationPageTitle";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

orderConfirmationPageTitleStyles.container = {
    css: css`
        display: flex;
        column-gap: 36px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        align-items: baseline;
        margin-bottom: 20px;
        width: 100%;
    `,
};
orderConfirmationPageTitleStyles.heading = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
        @media print {
            font-size: ${fontConfig.fontSize.pageTitle}px !important;
        }
    `,
};
orderConfirmationPageTitleStyles.continueButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
